import React from 'react';
import { PointsAndRankWrapper } from './styles';
import { Points } from './points';
import { Rank } from './rank';
import { useNavigate } from 'components/header/components/searchbar/hooks/use-navigate';

export interface IPointAndRank {
  points: number | null;
  pointsLoading: boolean;
  rankLabel: string | null;
  rankLoading: boolean;
  proCard: boolean;
}

export const QA_LOYALTY_POINTS_AND_RANK = 'loyalty-points-and-rank';

export const PointAndRank: React.FC<IPointAndRank> = ({
  points,
  pointsLoading,
  rankLoading,
  rankLabel,
  proCard,
}) => {
  const navigate = useNavigate();

  return (
    <PointsAndRankWrapper data-qa={QA_LOYALTY_POINTS_AND_RANK} onClick={() => navigate('/lk/loyalty')}>
      <Points loading={pointsLoading} points={points} />
      {proCard && <Rank loading={rankLoading} rankLabel={rankLabel} />}
    </PointsAndRankWrapper>
  );
};
